import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvanoCheckboxModule } from '@avano/avano-components/avano-checkbox/avano-checkbox.module';
import { AvanoRadioCheckboxGroupModule } from '@avano/avano-components/avano-radio-checkbox-group/avano-radio-checkbox-group.module';
import { AvanoRadiobuttonModule } from '@avano/avano-components/avano-radiobutton/avano-radiobutton.module';
import {
  AvanoToggleButtonGroupModule
} from '@avano/avano-components/avano-toggle-button-group/avano-toggle-button-group.module';
import { AvanoAppHeaderModule } from './avano-appheader/avano-appheader.module';
import { AvanoBoxModule } from './avano-box/avano-box.module';
import { AvanoButtonBarModule } from './avano-button-bar/avano-button-bar.module';
import { AvanoButtonModule } from './avano-button/avano-button.module';
import { AvanoComboboxModule } from './avano-combobox/avano-combobox.module';
import { AvanoDividerModule } from './avano-divider/avano-divider.module';
import { AvanoFeedbackModule } from './avano-feedback';
import { AvanoMenuModule } from './avano-menu/avano-menu.module';
import { AvanoMoreLessInformationModule } from './avano-more-less-information/avano-more-less-information.module';
import { AvanoPanelModule } from './avano-panel/avano-panel.module';
import { AvanoPopoverModule } from './avano-popover/avano-popover.module';
import { AvanoRequiredIconModule } from './avano-required-icon/avano-required-icon.module';
import { AvanoSearchToggleModule } from './avano-search-toggle/avano-search-toggle.module';
import { AvanoTableModule } from './avano-table/avano-table.module';
import { AvanoTabsModule } from './avano-tabs/tabs.module';
import { AvanoToggleSwitchModule } from './avano-toggle-switch/avano-toggle-switch.module';
import { AvanoUnsavedChangesModule } from './avano-unsaved-changes/avano-unsaved-changes.module';
import { ValidationModule } from './avano-validation/validation.module';
import { AvanoDirectivesModule } from './directives/avano-directives.module';
import { AvanoPipesModule } from './pipes/avano-pipes.module';
import { AvanoTableHeaderCheckboxModule } from './primeng-wrapper/avano-table-header-checkbox/avano-table-header-checkbox.module';

@NgModule({
  imports: [CommonModule],
  exports: [
    AvanoCheckboxModule,
    AvanoComboboxModule,
    AvanoRadioCheckboxGroupModule,
    AvanoMenuModule,
    AvanoSearchToggleModule,
    AvanoAppHeaderModule,
    AvanoButtonModule,
    AvanoButtonBarModule,
    AvanoDividerModule,
    AvanoBoxModule,
    AvanoDirectivesModule,
    AvanoMoreLessInformationModule,
    AvanoFeedbackModule,
    AvanoPanelModule,
    AvanoPipesModule,
    AvanoPopoverModule,
    AvanoRadiobuttonModule,
    AvanoTableModule,
    AvanoTableHeaderCheckboxModule,
    AvanoTabsModule,
    AvanoToggleSwitchModule,
    AvanoToggleButtonGroupModule,
    AvanoUnsavedChangesModule,
    AvanoRequiredIconModule,
    ValidationModule
  ],
})
export class AvanoComponentsModule {}
